import { OnInit } from '@angular/core';

export class GlobalTrendsRequest {
    start_date: string;
    end_date: string;
    market: string;
    endpoint: string;
    aggregation: string;
    dataset_type: string;
    top: number;
    time_tag: string;
    filter: string[];
    genetype: string;
    portfolio: portfolio;
    action: string;
    distribution: distribution;
    graph: string;
    username: string;
}

export class portfolio {
    type: string;
    value: string[];
}

export class distribution {
    percentile: number;
    type: string;
}


// WEBPACK FOOTER //
// ./src/app/globaltrends/globaltrends-request.ts